import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

import { BillingData, BillingPeriod } from '@/components/ReservationContext'
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/ui/card'

import { BillingControls } from './BillingControls'

interface BillingChartWithControlsProps {
    billingData: BillingData[]
    periodLabel: string
    selectedDate: Date
    selectedPeriod: BillingPeriod
    onDateChange: (date: Date | undefined) => void
    onPeriodChange: (period: string) => void
}

// Custom tick component to make the last label bold
const CustomTick = ({ x, y, payload, billingData }: any) => {
    const isLastLabel = billingData && payload.index === billingData.length - 1

    return (
        <g transform={`translate(${x},${y})`}>
            <text
                x={0}
                y={0}
                dy={16}
                textAnchor='end'
                fill='#666'
                fontSize={isLastLabel ? 14 : 12}
                fontWeight={isLastLabel ? 'bold' : 'normal'}
                transform='rotate(-45)'
            >
                {payload.value}
            </text>
        </g>
    )
}

export function BillingChartWithControls({
    billingData,
    periodLabel,
    selectedDate,
    selectedPeriod,
    onDateChange,
    onPeriodChange,
}: BillingChartWithControlsProps) {
    return (
        <Card>
            <CardHeader>
                <div className='flex items-center justify-between'>
                    <div className='space-y-1'>
                        <CardTitle>Estadísticas de Facturación</CardTitle>
                        <p className='text-sm text-muted-foreground'>{periodLabel}</p>
                    </div>
                    <BillingControls
                        selectedDate={selectedDate}
                        selectedPeriod={selectedPeriod}
                        onDateChange={onDateChange}
                        onPeriodChange={onPeriodChange}
                    />
                </div>
            </CardHeader>
            <CardContent>
                <div className='h-[400px]'>
                    <ResponsiveContainer width='100%' height='100%'>
                        <BarChart data={billingData} margin={{ top: 20, right: 30, left: 20, bottom: 70 }}>
                            <CartesianGrid strokeDasharray='3 3' />
                            <XAxis
                                dataKey='name'
                                angle={-45}
                                textAnchor='end'
                                height={70}
                                interval={0}
                                tick={<CustomTick billingData={billingData} />}
                            />
                            <YAxis
                                tick={{ fontSize: 12 }}
                                tickFormatter={value => `${value.toLocaleString('es-ES')}€`}
                            />
                            <Tooltip formatter={(value: number) => `${value.toLocaleString('es-ES')}€`} />
                            <Legend
                                layout='horizontal'
                                verticalAlign='top'
                                align='center'
                                wrapperStyle={{
                                    paddingBottom: '20px',
                                }}
                            />
                            <Bar dataKey='hotel' name='Hotel' fill='#4B6BFB' />
                            <Bar dataKey='peluqueria' name='Peluquería' fill='#10B981' />
                            <Bar dataKey='tienda' name='Tienda' fill='#F59E0B' />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </CardContent>
        </Card>
    )
}
